// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"styles_spinnerContainer__J-Vik","hide":"styles_hide__zUF77"};